import { Input, NumberInput, Select } from '@/src/components/Antd';
import LinkLibrary from '@/src/constrains/LinkLibrary';
import React from 'react';
import {
  Item as ItemWrapper,
  SectionContainer as Section,
} from 'src/components/Layouts';
import PositionOptions from 'src/components/PositionOptions';
import Slider from 'src/components/Slider/MarginSlider';
import { EnumPosition } from 'src/types/common/common';
import { ELayerType, EPositionOption } from 'src/types/common/module';
//import css from './css.module.less';
const Option = Select.Option;
//import Editor from 'src/constrains/BraftEditor';
import {
  // ImageDisplaySetting,
  useSingleImageEffect,
} from '@/src/components/Upload';
import { get, includes, isNumber } from 'lodash';
import FocusPoint from 'src/components/ImageFocusPointEdit';
import { ResponsiveRichEdit } from 'src/components/Modules/Components';
import { Uploader } from 'src/components/Upload';
import { layerErrorKey } from 'src/constrains/DraggableModules/tools';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
const Layer = (props) => {
  // const i18n = useI18n();
  // const getI18n = (str) => i18nGet(i18n, str);
  const {
    data,
    onChange,
    linkSet,

    specificError,
    isConvertible,
    buttons,
    animations,
    hoverAnimations,
    displayError,
  } = props;

  //console.log('specificError', specificError);
  const btnLinkModule = get(specificError, layerErrorKey.btnLinkModule) || [];
  const btnText = get(specificError, layerErrorKey.btnText) || [];
  const btnTheme = get(specificError, layerErrorKey.btnTheme) || [];
  const imageImage = get(specificError, layerErrorKey.imageImage) || [];
  const imageLinkModule =
    get(specificError, layerErrorKey.imageLinkModule) || [];
  const {
    layerType,
    buttonThemeUuid,
    linkModule,
    marginToLeft,
    marginToTop,
    hoverEffectUuid = null,
    entranceUuid = null,
    image,
    positionOption,
    buttonText,
    marginToCenter,
    imageWidth,
    text,
    textWidth,
    marginToHCenter,
    marginToVCenter,
    marginToRight,
    marginToBottom,
    content,
  } = data || {};
  //

  const renderBody = () => {
    if (layerType === ELayerType.BUTTON) {
      return (
        <ButtonLayer
          isConvertible={isConvertible}
          error={{ linkModule: btnLinkModule, text: btnText, theme: btnTheme }}
          onChange={onChange}
          linkSet={linkSet}
          data={{
            layerType,
            positionOption,
            marginToCenter,
            marginToLeft,
            marginToTop,
            hoverEffectUuid,
            entranceUuid,
            buttonText,
            buttonThemeUuid,
            linkModule,
            marginToHCenter,
            marginToVCenter,
            marginToRight,
            marginToBottom,
          }}
          listData={{ buttons, animations, hoverAnimations }}
        />
      );
    }
    if (layerType === ELayerType.IMAGE) {
      return (
        <ImageLayer
          isConvertible={isConvertible}
          onChange={onChange}
          linkSet={linkSet}
          error={{
            linkModule: imageLinkModule,
            image: imageImage,
          }}
          data={{
            layerType,
            positionOption,
            marginToLeft,
            marginToTop,
            hoverEffectUuid,
            entranceUuid,
            image,
            imageWidth,
            linkModule,
            marginToHCenter,
            marginToVCenter,
            marginToRight,
            marginToBottom,
          }}
          listData={{ buttons, animations, hoverAnimations }}
        />
      );
    }
    if (layerType === ELayerType.TEXT) {
      return (
        <TextLayer
          displayError={displayError}
          isConvertible={isConvertible}
          onChange={onChange}
          linkSet={linkSet}
          data={{
            layerType,
            positionOption,
            marginToLeft,
            marginToTop,
            hoverEffectUuid,
            entranceUuid,
            text,
            textWidth,
            marginToHCenter,
            marginToVCenter,
            marginToRight,
            marginToBottom,
            content,
            //linkModule,
          }}
          listData={{ buttons, animations, hoverAnimations }}
        />
      );
    }
  };
  return (
    <React.Fragment>
      {!isConvertible && (
        <Section size='small' bottomBorder>
          <ItemWrapper size='small' title='Layer Type'>
            <Select
              size='large'
              value={layerType}
              onChange={(layerType) => {
                onChange({ layerType });
              }}>
              <Option value={ELayerType.BUTTON}>Button</Option>
              <Option value={ELayerType.IMAGE}>Image</Option>
              <Option value={ELayerType.TEXT}>Text</Option>
            </Select>
          </ItemWrapper>
        </Section>
      )}

      {renderBody()}
    </React.Fragment>
  );
};

export default Layer;

const sliderGenerator = (data, onChange) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { positionOption } = data;
  const generator = (list) => {
    return (
      <React.Fragment>
        {list.map((i) => {
          const { title, key, position } = i;
          return (
            <Slider
              key={key}
              value={data[key]}
              onChange={(value) => {
                // console.log('marginToLeft', marginToLeft);
                onChange({ [key]: value });
              }}
              title={title}
              position={position}
            />
          );
        })}
      </React.Fragment>
    );
  };

  const len = (positionOption || []).length;
  if (len === 1) {
    if (includes(positionOption, EPositionOption.Center)) {
      return (
        <React.Fragment>
          {generator([
            {
              title: 'Margin to Horizontal Centre Line',
              key: 'marginToHCenter',
              position: EnumPosition.center,
            },
            {
              title: 'Margin to Vertical Centre Line',
              key: 'marginToVCenter',
              position: EnumPosition.center,
            },
          ])}
        </React.Fragment>
      );
    }
  }
  if (len === 2) {
    if (includes(positionOption, EPositionOption.Center)) {
      if (includes(positionOption, EPositionOption.Bottom)) {
        return (
          <React.Fragment>
            {generator([
              {
                title: 'Margin to Horizontal Centre Line',
                key: 'marginToHCenter',
                position: EnumPosition.center,
              },
              {
                title: getI18n('general.margintoBottomEdge'),
                key: 'marginToBottom',
                position: EnumPosition.bottom,
              },
            ])}
          </React.Fragment>
        );
      }
      if (includes(positionOption, EPositionOption.Top)) {
        return (
          <React.Fragment>
            {generator([
              {
                title: 'Margin to Horizontal Centre Line',
                key: 'marginToHCenter',
                position: EnumPosition.center,
              },
              {
                title: getI18n('general.margintoTopEdge'),
                key: 'marginToTop',
                position: EnumPosition.top,
              },
            ])}
          </React.Fragment>
        );
      }
      if (includes(positionOption, EPositionOption.Left)) {
        return (
          <React.Fragment>
            {generator([
              {
                title: 'Margin to Left Edge',
                key: 'marginToLeft',
                position: EnumPosition.left,
              },
              {
                title: 'Margin to Vertical Centre Line',
                key: 'marginToVCenter',
                position: EnumPosition.center,
              },
            ])}
          </React.Fragment>
        );
      }
      if (includes(positionOption, EPositionOption.Right)) {
        return (
          <React.Fragment>
            {generator([
              {
                title: 'Margin to Right Edge',
                key: 'marginToRight',
                position: EnumPosition.right,
              },
              {
                title: 'Margin to Vertical Centre Line',
                key: 'marginToVCenter',
                position: EnumPosition.center,
              },
            ])}
          </React.Fragment>
        );
      }
    } else {
      if (includes(positionOption, EPositionOption.Bottom)) {
        if (includes(positionOption, EPositionOption.Left)) {
          return (
            <React.Fragment>
              {generator([
                {
                  title: 'Margin to Left Edge',
                  key: 'marginToLeft',
                  position: EnumPosition.left,
                },
                {
                  title: getI18n('general.margintoBottomEdge'),
                  key: 'marginToBottom',
                  position: EnumPosition.bottom,
                },
              ])}
            </React.Fragment>
          );
        }
        if (includes(positionOption, EPositionOption.Right)) {
          return (
            <React.Fragment>
              {generator([
                {
                  title: 'Margin to Right Edge',
                  key: 'marginToRight',
                  position: EnumPosition.right,
                },
                {
                  title: getI18n('general.margintoBottomEdge'),
                  key: 'marginToBottom',
                  position: EnumPosition.bottom,
                },
              ])}
            </React.Fragment>
          );
        }
      }
      if (includes(positionOption, EPositionOption.Top)) {
        if (includes(positionOption, EPositionOption.Left)) {
          return (
            <React.Fragment>
              {generator([
                {
                  title: 'Margin to Left Edge',
                  key: 'marginToLeft',
                  position: EnumPosition.left,
                },
                {
                  title: getI18n('general.margintoTopEdge'),
                  key: 'marginToTop',
                  position: EnumPosition.top,
                },
              ])}
            </React.Fragment>
          );
        }
        if (includes(positionOption, EPositionOption.Right)) {
          return (
            <React.Fragment>
              {generator([
                {
                  title: 'Margin to Right Edge',
                  key: 'marginToRight',
                  position: EnumPosition.right,
                },
                {
                  title: getI18n('general.margintoTopEdge'),
                  key: 'marginToTop',
                  position: EnumPosition.top,
                },
              ])}
            </React.Fragment>
          );
        }
      }
    }
  }
  return null;
};

const TextLayer = (props) => {
  // const i18n = useI18n();
  // const getI18n = (str) => i18nGet(i18n, str);
  const {
    onChange,
    data,
    linkSet,
    isConvertible,
    listData, // displayError
  } = props;
  const {
    positionOption,
    hoverEffectUuid = null,
    entranceUuid = null,
    // text,
    //textWidth,
    content,
  } = data || {};
  const { animations, hoverAnimations } = listData;

  return (
    <React.Fragment>
      <ResponsiveRichEdit
        content={content}
        onChange={onChange}
        linkSet={linkSet}
        //displayError={displayError}
        isConvertible={isConvertible}
      />

      <Section size='small' bottomBorder>
        <ItemWrapper size='small' title='Position Option'>
          <PositionOptions
            data={positionOption || []}
            onChange={(positionOption) => {
              onChange({ positionOption });
            }}
          />
        </ItemWrapper>
        {sliderGenerator(data, onChange)}
      </Section>
      {!isConvertible && (
        <Section size='small' bottomBorder>
          <ItemWrapper size='small' title='Entrance Effect'>
            <Select
              size='large'
              value={entranceUuid}
              onChange={(entranceUuid) => {
                onChange({ entranceUuid });
              }}>
              <Select.Option value={null}>None</Select.Option>
              {(animations || []).map((i) => {
                const { uuid, name } = i || {};
                return (
                  <Option value={uuid} key={uuid}>
                    {name}
                  </Option>
                );
              })}
            </Select>
          </ItemWrapper>
          <ItemWrapper size='small' title='Hover Effect'>
            <Select
              size='large'
              value={hoverEffectUuid}
              onChange={(hoverEffectUuid) => {
                onChange({ hoverEffectUuid });
              }}>
              <Select.Option value={null}>None</Select.Option>
              {(hoverAnimations || []).map((i) => {
                const { uuid, name } = i || {};
                return (
                  <Option value={uuid} key={uuid}>
                    {name}
                  </Option>
                );
              })}
            </Select>
          </ItemWrapper>
        </Section>
      )}
    </React.Fragment>
  );
};

const ButtonLayer = (props) => {
  // const i18n = useI18n();
  // const getI18n = (str) => i18nGet(i18n, str);
  const { onChange, data, linkSet, listData, error, isConvertible } = props;
  const {
    linkModule: linkModuleError,
    text: textError,
    theme: themeError,
  } = error;
  const {
    positionOption,
    hoverEffectUuid = null,
    entranceUuid = null,
    buttonText,
    linkModule,
    buttonThemeUuid,
  } = data || {};
  // //listData={{ buttons, animations, hoverAnimations }}
  const { buttons, animations, hoverAnimations } = listData;

  return (
    <React.Fragment>
      <Section size='small' bottomBorder>
        <ItemWrapper size='small' title='Button Theme*'>
          <Select
            error={themeError.length > 0}
            help={themeError.join(' ')}
            size='large'
            value={buttonThemeUuid}
            placeholder='Please select a button theme'
            onChange={(buttonThemeUuid) => {
              onChange({ buttonThemeUuid });
            }}>
            {(buttons || []).map((i) => {
              const { uuid, name } = i || {};
              return (
                <Option value={uuid} key={uuid}>
                  {name}
                </Option>
              );
            })}
          </Select>
        </ItemWrapper>
        {!isConvertible && (
          <ItemWrapper size='small' title='Button Text*'>
            <Input
              error={textError.length > 0}
              help={textError.join(' ')}
              size='large'
              maxLength={40}
              value={buttonText}
              placeholder='Please input button text'
              onChange={(buttonText) => {
                onChange({ buttonText });
              }}
            />
          </ItemWrapper>
        )}
        {!isConvertible && (
          <ItemWrapper size='small' title='Button Link*'>
            <LinkLibrary
              // error={linkModuleError.length > 0}
              error={linkModuleError.join(' ')}
              noWrapper
              data={linkModule}
              onChange={(linkModule) => {
                onChange({ linkModule });
              }}
              linkSet={linkSet}
            />
          </ItemWrapper>
        )}
      </Section>
      <Section size='small' bottomBorder>
        <ItemWrapper size='small' title='Position Option'>
          <PositionOptions
            data={positionOption || []}
            onChange={(positionOption) => {
              onChange({ positionOption });
            }}
          />
        </ItemWrapper>
        {sliderGenerator(data, onChange)}
      </Section>
      {!isConvertible && (
        <Section size='small' bottomBorder>
          <ItemWrapper size='small' title='Entrance Effect'>
            <Select
              size='large'
              value={entranceUuid}
              onChange={(entranceUuid) => {
                onChange({ entranceUuid });
              }}>
              <Select.Option value={null}>None</Select.Option>
              {(animations || []).map((i) => {
                const { uuid, name } = i || {};
                return (
                  <Option value={uuid} key={uuid}>
                    {name}
                  </Option>
                );
              })}
            </Select>
          </ItemWrapper>
          <ItemWrapper size='small' title='Hover Effect'>
            <Select
              size='large'
              value={hoverEffectUuid}
              onChange={(hoverEffectUuid) => {
                onChange({ hoverEffectUuid });
              }}>
              <Select.Option value={null}>None</Select.Option>
              {(hoverAnimations || []).map((i) => {
                const { uuid, name } = i || {};
                return (
                  <Option value={uuid} key={uuid}>
                    {name}
                  </Option>
                );
              })}
            </Select>
          </ItemWrapper>
        </Section>
      )}
    </React.Fragment>
  );
};
const ImageLayer = (props) => {
  // const i18n = useI18n();
  // const getI18n = (str) => i18nGet(i18n, str);
  //const [imageSettingVisible, setImageSettingVisible] = React.useState(false);
  const { onChange, data, linkSet, listData, error, isConvertible } = props;
  const { linkModule: linkModuleError, image: imageError } = error;
  const {
    positionOption,

    hoverEffectUuid = null,
    entranceUuid = null,
    imageWidth,
    linkModule,
    image,
  } = data || {};
  const { animations, hoverAnimations } = listData;
  const [fileList, setFileList] = React.useState(image ? [image] : []);
  // const imageSettingFocus = get(image, 'imageSetting.focus');
  // const imageSettingLeft = get(image, 'imageSetting.left');
  // const imageSettingRight = get(image, 'imageSetting.right');
  // const imageSettingTop = get(image, 'imageSetting.top');
  // const imageSettingBottom = get(image, 'imageSetting.bottom');
  // const imageUrl = get(image, 'url');

  //console.log('fileList', fileList);
  useSingleImageEffect(image, fileList, setFileList);
  // const handleInImageSettingChange = ({ value, focalValue }) => {
  //   setImageSettingVisible(false);
  //   const { leftTop, leftBottom, rightBottom, rightTop } = value || {};
  //   const setting = {
  //     left: leftTop,
  //     right: rightBottom,
  //     top: rightTop,
  //     bottom: leftBottom,
  //   };
  //   const focus = focalValue;
  //   const imageSetting = {
  //     ...setting,
  //     focus,
  //   };
  //   const _image = { ...(image || {}), imageSetting };
  //   onChange({ image: _image });
  // };

  //console.log('listData', listData);
  return (
    <React.Fragment>
      {/* {imageSettingVisible && (
        <ImageDisplaySetting
          src={imageUrl}
          value={
            imageSettingLeft &&
            imageSettingLeft &&
            imageSettingRight &&
            imageSettingTop
              ? {
                  leftTop: imageSettingLeft,
                  leftBottom: imageSettingBottom,
                  rightBottom: imageSettingRight,
                  rightTop: imageSettingTop,
                }
              : null
          }
          visible={imageSettingVisible}
          focalValue={imageSettingFocus}
          onCancel={() => setImageSettingVisible(false)}
          onOk={handleInImageSettingChange}
        />
      )} */}
      <Section size='small' bottomBorder>
        <ItemWrapper
          error={imageError.length > 0}
          errorText={imageError.join(' ')}
          title='Image'
          bottomTitle='Allowed file types: jpeg, gif, png'>
          <Uploader
            type='Image'
            multiple={false}
            height={180}
            fileList={fileList}
            onChange={(list: Array<any>) => {
              const length = list.length;
              const image = length ? list[length - 1] : null;
              setFileList(list);
              onChange({ image });
            }}
            // hideEdit={isConvertible}
            // // disabled={isConvertible}
            // hideReplace={isConvertible}
            // hideRemove={isConvertible}
          />
        </ItemWrapper>
        <FocusPoint image={image} onChange={onChange} />
        {/* {isConvertible && image && (
          <div className={css.edit}>
            {' '}
            <a onClick={() => setImageSettingVisible(true)}>
              Image Display Setting
            </a>
          </div>
        )} */}
        {!isConvertible && (
          <ItemWrapper size='small' title='Link*'>
            <LinkLibrary
              error={linkModuleError.join(' ')}
              noWrapper
              data={linkModule}
              onChange={(linkModule) => {
                onChange({ linkModule });
              }}
              linkSet={linkSet}
            />
          </ItemWrapper>
        )}
      </Section>
      <Section size='small' bottomBorder>
        <ItemWrapper title='Image Width' size='small'>
          <NumberInput
            suffix={'px'}
            value={imageWidth}
            min={0}
            size={'large'}
            onChange={(imageWidth) => {
              if (isNumber(imageWidth)) {
                onChange({ imageWidth });
                return;
              }
              onChange({ imageWidth: 0 });
            }}
          />
        </ItemWrapper>
      </Section>
      <Section size='small' bottomBorder>
        <ItemWrapper size='small' title='Position Option'>
          <PositionOptions
            data={positionOption || []}
            onChange={(positionOption) => {
              onChange({ positionOption });
            }}
          />
        </ItemWrapper>
        {sliderGenerator(data, onChange)}
      </Section>
      {!isConvertible && (
        <Section size='small' bottomBorder>
          <ItemWrapper size='small' title='Entrance Effect'>
            <Select
              size='large'
              value={entranceUuid}
              onChange={(entranceUuid) => {
                onChange({ entranceUuid });
              }}>
              <Select.Option value={null}>None</Select.Option>
              {(animations || []).map((i) => {
                const { uuid, name } = i || {};
                return (
                  <Option value={uuid} key={uuid}>
                    {name}
                  </Option>
                );
              })}
            </Select>
          </ItemWrapper>
          <ItemWrapper size='small' title='Hover Effect'>
            <Select
              size='large'
              value={hoverEffectUuid}
              onChange={(hoverEffectUuid) => {
                onChange({ hoverEffectUuid });
              }}>
              <Select.Option value={null}>None</Select.Option>
              {(hoverAnimations || []).map((i) => {
                const { uuid, name } = i || {};
                return (
                  <Option value={uuid} key={uuid}>
                    {name}
                  </Option>
                );
              })}
            </Select>
          </ItemWrapper>
        </Section>
      )}
    </React.Fragment>
  );
};
// const TextLayer = (props) => {};
